import { forwardRef } from 'react';
import './Button.css';

const Button = forwardRef(({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  danger = false,
  subtleDanger = false,
  className = '',
  type = 'button',
  children,
  ...rest
}, ref) => {
  const classes = [
    'design-system-btn',
    `btn-${variant}`,
    size !== 'md' ? `btn--${size}` : '',
    fullWidth ? 'btn--full' : '',
    danger ? 'btn--danger' : '',
    subtleDanger ? 'btn--subtle-danger' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button ref={ref} type={type} className={classes} {...rest}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
